export default "__VITE_ASSET__BHwKR5tg__"